module.exports = __webpack_public_path__ + "static/img/camo_max2.140a4d75.png";